import { AttentionTypes } from '../../Definitions'
import { Pages } from '../../Navigation/root'
import { LangFile } from './'

const Texts:LangFile = {
  // #region | General
  additional: "additional",
  and: "and",
  change: "change",
  choose: "choose",
  deleteFailed: "delete failed",
  editFailed: "edit failed",
  filterBy: "filter by",
  from: "from",
  general: "general",
  no: "no",
  noData: "No Data",
  noOptions: "No Options",
  of: "of",
  off: "off",
  on: "on",
  optional: "optional",
  page: "page",
  reset: "reset",
  required: "required",
  saveAlert: "Please save or cancel edit view.",
  search: "Search",
  select: "Select",
  success: "Success",
  to: "to",
  unknown: "unknown",
  wasUpdated: "was updated", //NEW 05-03-2026
  wasDeleted: "was deleted", //NEW 05-03-2026
  useSelectedTime: "use selected time",
  yes: "yes",
  // #endregion

  // Regarding the language list:
  // Please translate only your own language. 
  // If your language is not on the list, then add it using a maximum of two 
  // initials followed by a colon and the language in quotation marks.
  languages: { 
    en: "english",
    dk: "dansk",
    es: "español",
    de: "deutsch",
    ma: "mandarin",
    ko: "한국어",
    nl: "nederlands",
  },

  cookie: {
    header: "cookies",
    context1: "Agrisys A/s use cookies for the following purposes:",
    context2: "By pressing “Accept all” you accept our use of cookies. Else a minimun of cookies will be used required by the service to function, for example to manage login, and data fetching from the consys platfrom.",
    purpose1: "To support the website's functionality, for example by remembering your settings regarding cookies, preferred languages, currencies, etc.",
    purpose2: "To perform statistical analysis of your use of the website, for example by measuring what type of content you are looking at and clicking on.",
    accept: "Accept necessary",
    acceptAll: "Accept All"
  },

  // #region | Units
  units: {
    units: "units",
    capacity: "capacity",
    days: "days",
    g: "g",
    hour: "hour",
    hourAgo: "hour ago",
    hours: "hours",
    hoursAgo: "aours ago",
    kg: "KG",
    minutAgo: "minut ago",
    minutesAgo: "minutes ago",
    min: "min",
    pct: "PCT",
    timeToday: "time today",
    timesToday: "times today",
    total: "total",
    energy: "energy"
  },
  // #endregion

  // #region | Buttons
  buttons: {
    add: "add",
    apply: "apply",
    cancel: "cancel",
    commit: "commit",
    confirm: "confirm",
    create: "create",
    csv: "csv",
    deselectAll: "deselect all",
    details: "details",
    edit: "edit",
    excel: "excel",
    filter: "Filter",
    goBack: "go back",
    menu: "menu",
    move: "move",
    next: "next",
    options: "options",
    prev: "prev",
    print: "print",
    resetFilters: "reset filters",
    save: "save",
    selectAll: "select all"
  },
  // #endregion

  // #region | Menu Headers
  menuHeaders: {
    overview: "overview",
    globalMenu: "global menu",
    systemMenu: "system menu",
    attentions: "attentions",
    quickEntry: "quick entry",
    language: "language",
    [Pages.dashboard]: "dashboard",
    [Pages.kpi]: "kpi",
    [Pages.feedCurves]: "feed curves",
    [Pages.components]: 'components',
    [Pages.componentsAlternatives]: "component alternatives",
    [Pages.mixtures]: "mixtures",
    [Pages.silos]: "silos",
    [Pages.silosSettings]: "silo Settings",
    [Pages.animal]: "animal",
    [Pages.animals]: "animals",
    [Pages.animalsGroups]: "animal groups",
    [Pages.reports]: "reports",
    [Pages.archive]: 'archive',
    [Pages.logbook]: "logbook",
    [Pages.globalSettings]: "settings",
    [Pages.devices]: "devices",
    [Pages.freeda_lf]: "overview",
    [Pages.freeda_lf_sections]: 'sections',
    [Pages.freeda_lf_settings]: 'settings',
    [Pages.op_operations]: 'operations',
    [Pages.op_quickEntry]: 'Quick Entry',
    [Pages.freeda_esf]: "overview",
    [Pages.freeda_esf_sections]: "sections",
    [Pages.freeda_esf_settings]: "settings"
  },
  // #endregion

  // #region | User
  user: {
    userInformation: "user information",
    user: "user",
    userName: "User Name",
    firstName: "First Name",
    lastName: "Last Name",
    phone: "Phone",
    email: "Email",
    password: "Password",
    repeatPassword: "Repeat password",
    country: "Country",
    address: "Address"
  },
  // #endregion

  // #region | Farm
  farm: {
    farmInformation: "farm information",
    farmName: "farm name",
    city: "city",
    street: "street",
    phone: "phone",
    vat: "vat",
    email: "email"
  },
  // #endregion

  // #region | Milestones
  milestones: {
    general: {
      milestone: "milestone",
      milestones: "milestones",
      noMilestoneFound: "no milestone found",
      animalsInMilestones: "animals in milestones",
      latestMilestone: "curr. milestone",
      milestoneDay: "curr. milestone day",
      newMilestone: "New milestone"
    },
    defaultMilestones: {
      farrowing: "Farrowing",
      insemination: "Insemination",
      weaning: "Weaning",
      movedToFarrowing: "Moved To Farrowing"
    }
  },
  // #endregion

  // #region | Events
  events: { 
    events: "events", 
    eventName: "name", 
    eventDate: "date", 
    eventNote: "note", 
    addEvent: "add event", 
  },
  // #endregion

  // #region | Devices
  devices: {
    devices: "devices",
    name: "name",
    cpuId: "cpu id",
    type: "Type",
    connection: "connection",
    system: "system",
    noControllersFound: "no lan controllers found",
    lanControllers: "lan controllers",
    newLcBoard: "new lc board",
    boardName: "board name",
    noIoBoards: "no i/o boards found",
    ioBoards: "i/o boards",
    newIoBoard: "new i/o board",
    layout: "layout",
    horizontal: "Horizontal",
    vertical: "Vertical",
    asc: "Ascending",
    desc: "Descending",
    columns: "columns",
    rows: "rows",
    order: "order",
    direction: "direction",
    chooseIo: "choose i/o",
    remainingInputs: "remaining inputs",
    remainingOutputs: "remaining outputs",
    aicoIo: "I/O Board",
    output: "Output",
    input: "Input",
    board: "board",
    moveBoard: "move board",
    noTerminals: "No Terminals",
    terminalPort: "Terminal Port",
    pen: "Pen",
    ioSpecifications: "i/o specifications",
    numbering: "numbering",
    manual: "manual",
    automatic: "automatic",
    pattern: "pattern",
    topLeft: "top left",
    topRight: "top right",
    bottomLeft: "bottom left",
    bottomRight: "bottom right",
    startCorner: "start corner",
  },
  // #endregion

  // #region | System Controls
  systemControls: {
    general: {
      startSystem: "start system",
      systemControls: "system controls",
      emergencyStop: "emergency stop",
      stopSystem: "stop system",
      startAll: "start all",
      startSection: "start section",
      startSelected: "start selected",
      calibrateSection: "calibrate section",
      calibrateSelected: "calibrate selected",
      emptySection: "empty section",
      emptySelected: "empty selected",
      clickPen: "Click every pen you want to select",
      unClickPen: "Click every pen you want to deselect",
      orSelectAll: "Or select all",
      orDeselectAlle: "Or deselect all",
      problem: "problem",
      problems: "problems",
      warning: "warning",
      warnings: "warnings",
      attention: "attention",
      attentions: "attentions",
      attentionType: "Attention type",
      systemState: "System state",
      staticFeeding: "Static Feeding",
      nextFeeding: "Next Feeding",
      resolvedWeight: "resolved weight",
      noPensSelected: "No pens selected",
      feeding: "Feeding",
      feedingFailed: "Feeding failed",
      calibrating: "Calibrating",
      calibratingFailed: "Calibrating failed",
      changeTime: "Change time",
      emptyingFor: "Emptying for",
      emptyingFailed: "Emptying failed",
      confirmStop: "Would you like to proceed the emergency stop of the system?",
      goToSystem: "go to system",
      systemStatus: "system status",
      date: "date",
      level: "level",
      type: "type",
      inspect: "inspect",
      delete: "delete",
      logid: "log id",
      system: "System",
      motor: "Motor",
      animal: "Animal",
      alerts: "alerts",
      location_name: "Location Name",
      fk_lan_controllers: "FK Lan Controllers",
      lan_controller_log_id: "Lan Controller Log ID",
      attention_message: "Attention Message",
      attention_time: "Attention Time",
      runningWith: "running with",
      technicalData: "Technical data",
    },
    states: {
      [AttentionTypes.good]: "Running",
      [AttentionTypes.neutral]: "Off",
      [AttentionTypes.warning]: "Warning",
      [AttentionTypes.alert]: "Alert"
    },
    createSystem: {
      createNewSystem: "create new system", 
      systemName: "system name",
      systemType: "system type", 
    },
    blueprint: {
      blueprint: "blueprint",
      upload: "upload",
      wrongType: "Error processing file",
      wrongSize: "File is too large (max 500 kB)",
      pleaseDropImage: "Please drop a JPEG file",
      pleaseSelectImage: "Please select a JPEG file",
      dropImage: "Drag and drop your blueprint here",
      browseImage: "Or browse it from your computer",
      chooseFile: "Choose file",
      chooseAgain: "choose again"
    }
  },
  // #endregion

  // #region | Motor Specs
  motorSpecs: {
    general: {
      skipCnt: "skip count",
      skipTime: "skip time",
      powerConsumption: "power consumption",
      calibrationValue: "calibration value",
      rotationTime: "rotation time",
      statusMode: "status mode",
      noSkip: "No Skip",
      noPowerConsumption: "No Power Consumption",
      noCalibrationValue: "No Calibration Value",
      noRotationTime: "No Rotation Time",
      noStatusMode: "No Status Mode",
    }
  },
  // #endregion
  
  // #region | Params
  params: {
    animal: "Animal",
    animalId: "Animal No.",
    location: "Location",
    feedCurve: "Feed Curve",
    group: "Group",
    condition: "Condition",
    removeAnimals: "Move animals",
    resetTotalConsumed: "Reset total consumed",
    manualFeedStart: "Manual feed start",
    clearCalendarEvents: "Empty alendar events",
    insemination: "Insemination",
    weaning: "Weaning",
    farrowing: "Farrowing",
    pregnancyCheck: "Pregnancy Check",
    birthDate: "Birth Date",
    pregnant: "Pregnant",
    responderNo: "Responder No.",
    lifeNo: "Life No.",
    animalType: "Animal Type",
    milestone: "Milestone",
    system: "System",
    excess_remaining: "Missing more than",
  },
  negativeParams: {
    animal: "No Animal",
    animalId: "No Animal No.",
    location: "No Location",
    feedCurve: "No Feed Curve",
    group: "No Group",
    condition: "No Condition",
    birthDate: "No Birth Date",
    pregnant: "Not Pregnant",
    responderNo: "No Responder No.",
    lifeNo: "No Life No.",
    animalType: "No Animal Type",
    milestone: "No Milestone",
    system: "No System",
  },
  // #endregion

  configs: {},
  
  // #region | Feed
  feed: {
    general: {
      feed: "feed",
      feeding: "feeding",
      remainingToday: "Remaining today",
      remainingYesterday: "Remaining yesterday",
      waterUseToday: "Water use today",
      notFed: "fed <20% last two days",
      feedLastDays: "last 10 days",
      currentProgress: "current progress",
      fedLastPeriod: "fed last period",
      fedTotal: "fed total",
      feedConsumption: "feed consumption",
      feedBalance: "feed balance",
      consumedToday: "consumed today",
      consumedYesterday: "consumed yesterday"
    },
    feedCurve: {
      feedCurve: "Feed Curve",
      active: "active",
      noFeedCurve: "No feed curve found",
      default: "default",
      minFeedSpeed: "minimum feed speed (g/min)",
      maxFeedSpeed: "maximum feed speed (g/min)",
      feedSpeed: "feed speed",
    },
    feedCorrection: {
      increased: "increased",
      decreased: "decreased",
      disabled: "disabled",
      feedCorrection: "Feed Correction",
      feedCorrections: "Feed Corrections",
    },
    feedSkip: {
      feedSkip: "feed skip",
      skipFeeding: "skip feeding",
      noSkip: "no feed skip",
      skipForNow: "for now",
      planSkip: "plan",
      planFeedSkip: "plan feed skip",
      standardSkip: "standard",
      startFeeding: "start feeding",
      invalidDay: "invalid day",
      invalidTime: "invalid time",
      endDateBeforeStartDate: "the end date occurs before the start date",
      endTimeBeforeStartTime: "the end time occurs before the start time",
      timeSpan: "time span",
      timeAmount: "time amount",
      startDate: "start date",
      endDate: "end date",
      startTime: "start time",
      endTime: "end time",
      plannedSkip: "planned skip",
      recentFeedSkipSuccess: "Recent feed skip success status"
    }
  },
  // #endregion

  // #region | Login Flow
  loginFlow: {
    def: {
      fullView: "full view",
      focus_view: "focus view",
      goToSiteList: "Go to Site List",
      switchTofocus_view: "Switch to Focus View",
      switchToFullView: "Switch to Full View"
    },
    login: {
      login: "log in",
      logOut: "Log Out",
      welcomeBack: "welcome back",
      notRegisteredYet: "Not registered yet",
      createNewuser: "create new user",
      forgotPassword: "Forgot password",
      resetPassword: "reset password",
      missingUserName: "user name is missing",
      missingPassword: "password is missing",
      couldNotLogin: "failed to log in",
      noSitesFound: "no sites found"
    },
    forgotPassword: {
      forgotPassword: "forgot password",
      resetPassword: "reset password",
      text: "If there is no email assigned to the user name, please contact the support for further help.",
      text2: "Please don't close this window before the reset process is done.",
      noEmail: "No email assigned",
      contactSupport: "contact support",
      usernameRequired: "username required",
      noUsernameFound: "username does not excist"
    },
    resetPassword: {
      resetPassword: "reset password",
      text: `A temporary code has been sent to your email. Please write it below to create a new password.`,
      temporaryCode: "Temporary code",
      newPassword: "New password",
      repeatPassword: "Repeat new password",
      createNewPassword: "create new password",
      contactSupport: "contact support",
      noPasswordRevieved: "Didn't recieve a temporary code",
      newPasswordFail: "failed to create new password"
    },
    createUser: {
      newUser: "new user",
      missingUserName: "user name is missing",
      missingPassword: "password is missing",
      missingRepeatPassword: "please repeat password",
      passwordMismatch: "password mismatch",
      success: "success"
    },
    chooseSite: {
      chooseSite: "choose site",
      siteName: "site name",
      domain: "domain",
      id: "id",
      tools: "tools"
    }
  },
  // #endregion

  // #region | Widgets
  widgets: {
    general: {
      noWidgets: "There is at the moment no widgets on this page.",
      widgetOptions: "widget options",
      manageWidgets: "manage",
      name: "Name",
      type: "Type",
      widgetPriority: "Priority",
      createNew: "create new",
      copyExisting: "copy existing",
    },
    widgetTypes: {
      autoReports: "Auto Reports",
      autoReportsAndMore: "Auto Reports etc.",
      graph: "Graph",
      progress: "Progress Circles",
    },
    graph: {
      noGraphSelected: "No graph selected",
      graphIncludesStart: "The graph includes all animals",
      graphIncludesEnd: "that has feed consumption data",
      animalsToInclude: "Animals to include based on system",
      last10DaysConsumption: "Last 10 days feed consumption"
    },
    autoReports: {
      autoReports: "Auto Reports",
      navigatedFromSystem: "Navigated from system",
      add: "Add auto report",
      addExisting: "add existing"
    }
  },
  // #endregion

  // #region | Penlist
  penList: {
    basicDisclaimer: "Hold the mouse on a value to see column type",
    editDisclaimer: "Edit an animal by selecting new values",
    addDisclaimer: "Add an animal from the dropdown or remove it again on the bin icon",
    moveDisclaimer: "Move an animal to a new location from the dropdown or remove it from any location on the bin icon",
  },
  // #endregion

  // #region | Feed Curve pages
  feedCurvePages: {
    feedCurves: {
      copyFeedCurve: "copy feed curve",
      createFeedCurve: "create feed curve",
      createFeedCurveFromScratch: "Create feed curve from scratch",
      feedCurveDetails: "feed curve details",
      newFeedCurve: "new feed curve",
      feedCurveName: "feed curve name",
      fromFeedCurve: "from feed curve"
    },
    components: {
      components: "components",
      emptyText: "no components found",
      name: "component name",
      readyMixture: "ready to use",
      priority: "priority",
      ds: "ds",
      energy: "energy",
      protein: "protein"
    },
    feedCurve: {
      spreading: "spreading",
      settings: "settings",
      day: "day",
      watchFeedCurve: "watch feed curve",
      doNotPassFeed: "Do not pass feed",
      passFeed: "Pass feed",
      noStimuli: "No stimuli",
      addStimuli: "Add stimuli",
      singleStimuli: "Single stimuli",
      repeatStimuli: "Repeat stimuli",
      maxAmount: "max period amount (kg)",
      remainingFeed: "remaining feed",
      maxFeedToPass: "max KG to pass",
      feedStimuli: "feed stimuli",
      minutesApart: "minutes apart",
      addTime: "add time",
      saveChanges: "save changes",
      resetChanges: "reset changes"
    }
  },
  // #endregion

  // #region | Animal pages
  animalPages: {
    animals: {
      animals: "animals",
      emptyText: "No animals found",
      quickEntry: "quick entry",
      newAnimal: "new animal",
      viewChanges: "view changes",
      action: "action",
      selectAnimals: "select animals",
      missingAnimalNo: "animal no. is missing",
      missingResponderNo: "responder no. is missing",
      kgFedMore: "KG fed more than expected",
      noAnimalsMatchTheSelection: "No animals match the selection"
    },
    animalGroups: {
      group: "group",
      numberOfAnimals: "Number of Animals",
      createGroup: "create group",
      newGroup: "new group",
      groupName: "group name",
    },
    animal: {
      animal: "animal",
      basicInfo: "basic info",
      noAnimalSelected: "no animals selected",
      noAnimalsSelected: "no animal selected",
      addAnimal: "add animal",
      addAnimalToPen: "add animal to pen",
      pen: "pen",
      moveAnimal: "move animal",
      moveAnimals: "move animals",
      moveAnimalFromPen: "move animal to pen",
      goToAnimal: "go to animal page",
      totalCycleDay: "total cycle day",
      marking: "marking",
      events: "events",
      eventName: "Name",
      eventDate: "Date",
      eventNote: "Note",
      noTimeline: "no timeline",
      addEvent: "add event",
      timeline: "timeline",
      viewTimeline: "view timeline",
      born: "born",
      timelineShows: "timeline shows parity",
      parity: "parity",
    }
  },
  // #endregion

  // #region | Report pages
  reportPages: {
    reports: {
      template: "Template",
      templateName: "template name",
      addTemplate: "add template",
      copyTemplate: "copy template",
      createReport: "create report",
      createNewReport: "Start a new report from scratch",
      newTemplate: "new template",
      newReport: "new report",
      dataLevel: "data level",
      filterParameter: "filter parameter",
      dataParameter: "data parameter",
      reportName: "report name",
      archiveReport: "archive report",
      startDate: "start date",
      endDate: "end date",
      showInReport: "Show in Report",
      fromTemplate: "from template",
      noReportFound: "no report found",
      noDataParameterFound: "no data parameter found",
      unknownCondition: "unknown condition",
      unknownAnimalGroup: "ynknown group",
      noFilterParameterFound: "no filter parameter found",
      saveAsTemplate: "save as template",
    },
    report: {
      report: "report",
      editReport: "edit report",
      unArchiveReport: "unarchive report",
      saveAsTemplate: "save as template",
      noReport: "no report found"
    },
    archive: {
      archive: "archive",
      filterByNumber: "report number",
      filterByName: "report name alphabetical",
      archivedReport: "Archived report",
      noStartDateFound: "No start date found",
      noEndDateFound: "No end date found",
    }
  },
  // #endregion

  // #region | Logbook pages
  logPages: {
    logbook: {
      problem: "Problem",
      warning: "Warning",
      info: "Info",
      debug: "Debug",
      system: "System",
      motor: "Motor",
      animal: "Animal",
      time: "time",
      level: "level",
      type: "type",
      message: "message",
      location: "location",
      controller: "controller",
      allControllers: "all controllers",
      controllerName: "controller name",
      deviceName: "device name",
      lanControllers: "lan controllers",
      getLog: "get log",
      noLogsAvailable: "no logs available",
      responder: "responder",
    },
  },
  // #endregion

  // #region | Global Settings pages
  globalSettingsPages: {
    globalSettings: {
      imperial: "Imperial",
      metric: "Metric",
      saveChanges: "save changes",
      discardChanges: "discard changes",
      userManagement: "user management",
      timeZone: "time zone",
      feedDayStart: "feed day start",
      remove: "remove"
    }
  },
  // #endregion

  // #region | Location Feeder Pages
  locationFeederPages: {
    locationFeeder: {
      sections: "sections",
      pens: "pens",
      animals: "animals",
      sectionNo: "Section No.",
      pen: "Pen",
    },
    sections: {
      section: "section",
      sections: "sections",
      map: "map",
      animalAmount: "number of animals",
      penValueHeaders: "hold the mouse on a value to see column type",
      sectionNotFound: "section not found",
      emptyPen: "Empty pen",
      feeder: "feeder",
      inThisPen: "in this pen",
      activations: "activations",
      lastActivated: "last activated",
      newSection: "new section",
      sectionName: "section name",
      firstPenNo: "first pen no.",
      penAmount: "number of pens",
      clickOnPen: "Click on a pen to add it or remove it again.",
      penContent: "pen content",
      feederOnly: "Feeder only",
      water: "Water",
      activator: "Activator",
      feederOutput: "Feeder Output",
      waterOutput: "Water Output",
      activatorInput: "Activator Input",
      since: "since",
      redirect: "This will redirect you to the animal page.",
      expand: "expand",
      collapse: "collapse",
      noSections: "No sections found",
    },
    settings: {
      dailyRotation: "daily rotation",
      dailyRotationDisclaimer: "NB: If the location is empty or the animal has no feed curve assigned, the motor will perform a daily rotation for service purposes.",
      feedInSilos: "feed in silos",
      attentionLimit: "attention limit"
    }
  },
  // #endregion

  // #region | ESF Walk Through Pages
  esfWalkThroughPages: {
    esfWalkThrough: {
    },
    sections: {
      station: "station",
      feedMotor: "feed motor",
      feedSensor: "feed sensor",
      gateMotor: "gate motor",
      gateSensor: "gate sensor",
      inThisStation: "in this station",
      previously: "previously",
      feedComponents: "feed components",
      stationLastDays: "last 10 days",
      stationLog: "log"
    },
    settings: {
    }
  },
  // #endregion

  // #region | Focus View Pages
  focus_viewPages: {
    location: "location",
    system: "system",
    section: "section",
    inThisPen: "in this pen",
    today: "today",
    pen: "pen",
    since: "since",
    day: "Day",
    moveAnimal: "move animal",
    newLocation: "new location",
    emptyPen: "Empty pen",
  }
  // #endregion
}
export default Texts